import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Textarea } from '../../ui/textarea';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export function OdenekFormDialog({
  open, onOpenChange, editMode,
  formData, setFormData, displayMoney,
  onSubmit, submitting, onCancel,
  addEkTaahhut, removeEkTaahhut, updateEkTaahhut,
  addEkProtokol, removeEkProtokol, updateEkProtokol
}) {
  return (
    <Dialog open={open} onOpenChange={(val) => { if (!val && open) return; onOpenChange(val); }}>
      <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle data-testid="odenek-form-title">{editMode ? 'Ödenek Düzenle' : 'Yeni Ödenek/Taahhüt Ekle'}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Yıl *</Label>
              <Input type="number" value={formData.yil} onChange={(e) => setFormData({...formData, yil: parseInt(e.target.value)})} className="bg-gray-800 border-gray-700 text-white" required />
            </div>
            <div className="space-y-2">
              <Label>Talep Tarihi</Label>
              <Input type="date" value={formData.talep_tarihi} onChange={(e) => setFormData({...formData, talep_tarihi: e.target.value})} className="bg-gray-800 border-gray-700 text-white" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>İşin Adı *</Label>
            <Textarea value={formData.isin_adi} onChange={(e) => setFormData({...formData, isin_adi: e.target.value})} className="bg-gray-800 border-gray-700 text-white min-h-20" required />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Talep Yeri *</Label>
              <Select value={formData.talep_yeri} onValueChange={(value) => setFormData({...formData, talep_yeri: value})}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seçin" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="yigm">YİGM</SelectItem>
                  <SelectItem value="spor_toto">SPOR TOTO</SelectItem>
                  <SelectItem value="strateji">STRATEJİ</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Ödenek Türü *</Label>
              <Select value={formData.odenek_turu} onValueChange={(value) => setFormData({...formData, odenek_turu: value})}>
                <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seçin" /></SelectTrigger>
                <SelectContent className="bg-gray-800 border-gray-700 text-white">
                  <SelectItem value="taahhut">TAAHHÜT</SelectItem>
                  <SelectItem value="protokol">PROTOKOL</SelectItem>
                  {editMode && (
                    <>
                      <SelectItem value="ek_taahhut">EK TAAHHÜT</SelectItem>
                      <SelectItem value="ek_protokol">EK PROTOKOL</SelectItem>
                    </>
                  )}
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Talep Yazısı Sayı ve Numarası</Label>
              <Input value={formData.talep_yazisi_sayi_no} onChange={(e) => setFormData({...formData, talep_yazisi_sayi_no: e.target.value})} className="bg-gray-800 border-gray-700 text-white" />
            </div>
            <div className="space-y-2">
              <Label>Talep Tutarı (KDV Hariç)</Label>
              <Input value={displayMoney(formData.talep_tutari)} onChange={(e) => setFormData({...formData, talep_tutari: e.target.value.replace(/ TL/g, '')})} className="bg-gray-800 border-gray-700 text-white" placeholder="3600848,45" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Ödenek Durumu *</Label>
            <Select value={formData.odenek_durumu} onValueChange={(value) => setFormData({...formData, odenek_durumu: value})}>
              <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seçin" /></SelectTrigger>
              <SelectContent className="bg-gray-800 border-gray-700 text-white">
                <SelectItem value="geldi">GELDİ</SelectItem>
                <SelectItem value="gelmedi">GELMEDİ</SelectItem>
                <SelectItem value="iptal_edildi">İPTAL EDİLDİ</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* İhale Onayı */}
          {formData.odenek_durumu === 'geldi' && (
            <div className="p-4 bg-green-900/20 border border-green-700/50 rounded-lg space-y-4">
              <Label className="text-white font-medium">İhale Onayı Bilgileri</Label>
              <div className="space-y-2">
                <Label>İhale Onayı</Label>
                <Select value={formData.ihale_onayi || 'none'} onValueChange={(value) => setFormData({...formData, ihale_onayi: value === 'none' ? '' : value})}>
                  <SelectTrigger className="bg-gray-800 border-gray-700 text-white"><SelectValue placeholder="Seçin" /></SelectTrigger>
                  <SelectContent className="bg-gray-800 border-gray-700 text-white">
                    <SelectItem value="none">Seçilmedi</SelectItem>
                    <SelectItem value="geldi">Geldi</SelectItem>
                    <SelectItem value="gelmedi">Gelmedi</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>İhale Onayı Talep Tarihi</Label>
                  <Input type="date" value={formData.ihale_onayi_talep_tarihi || ''} onChange={(e) => setFormData({...formData, ihale_onayi_talep_tarihi: e.target.value})} className="bg-gray-800 border-gray-700 text-white" />
                </div>
                <div className="space-y-2">
                  <Label>İhale Onayı Talep Yazısı</Label>
                  <Input value={formData.ihale_onayi_talep_yazisi || ''} onChange={(e) => setFormData({...formData, ihale_onayi_talep_yazisi: e.target.value})} className="bg-gray-800 border-gray-700 text-white" placeholder="Yazı no / açıklama" />
                </div>
              </div>
            </div>
          )}

          {/* Ek Taahhüt/Protokol */}
          {editMode && (
            <div className="p-4 bg-yellow-900/20 border border-yellow-700/50 rounded-lg space-y-4">
              <Label className="text-white font-medium">İlave Ödenek Türü (Opsiyonel):</Label>

              {/* Ek Taahhütler */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label className="text-sm font-medium text-blue-300">Ek Taahhütler ({formData.ek_taahhutler?.length || 0})</Label>
                  <Button type="button" onClick={addEkTaahhut} size="sm" className="bg-blue-600 hover:bg-blue-700 text-white h-8">+ Ek Taahhüt Ekle</Button>
                </div>
                {formData.ek_taahhutler?.map((taahhut, index) => (
                  <EkSatirForm key={index} item={taahhut} index={index} type="Taahhüt" displayMoney={displayMoney}
                    onUpdate={(field, value) => updateEkTaahhut(index, field, value)} onRemove={() => removeEkTaahhut(index)} />
                ))}
              </div>

              {/* Ek Protokoller */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <Label className="text-sm font-medium text-purple-300">Ek Protokoller ({formData.ek_protokoller?.length || 0})</Label>
                  <Button type="button" onClick={addEkProtokol} size="sm" className="bg-purple-600 hover:bg-purple-700 text-white h-8">+ Ek Protokol Ekle</Button>
                </div>
                {formData.ek_protokoller?.map((protokol, index) => (
                  <EkSatirForm key={index} item={protokol} index={index} type="Protokol" displayMoney={displayMoney}
                    onUpdate={(field, value) => updateEkProtokol(index, field, value)} onRemove={() => removeEkProtokol(index)} />
                ))}
              </div>

              {/* TOPLAM */}
              <div className="mt-4 p-3 bg-blue-900/30 border border-blue-700/50 rounded">
                <div className="flex justify-between items-center">
                  <span className="text-blue-300 font-bold">TOPLAM TUTAR (KDV Hariç):</span>
                  <span className="text-blue-300 font-bold text-xl">
                    {(() => {
                      let total = 0;
                      const mainVal = parseFloat((formData.talep_tutari || '').replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
                      if (!isNaN(mainVal)) total += mainVal;
                      formData.ek_taahhutler?.forEach(t => {
                        const val = parseFloat((t.tutari || '').replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
                        if (!isNaN(val)) total += val;
                      });
                      formData.ek_protokoller?.forEach(p => {
                        const val = parseFloat((p.tutari || '').replace(/[^0-9,.]/g, '').replace(/\./g, '').replace(',', '.'));
                        if (!isNaN(val)) total += val;
                      });
                      return total.toLocaleString('tr-TR', {minimumFractionDigits: 2}) + ' TL';
                    })()}
                  </span>
                </div>
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button onClick={onCancel} variant="ghost" className="text-gray-400">İptal</Button>
          <Button onClick={onSubmit} disabled={submitting} className="bg-green-600 hover:bg-green-700 text-white">{submitting ? 'Kaydediliyor...' : (editMode ? 'Güncelle' : 'Oluştur')}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

function EkSatirForm({ item, index, type, displayMoney, onUpdate, onRemove }) {
  return (
    <div className="p-3 bg-gray-800/50 rounded border border-gray-700 space-y-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-gray-400">Ek {type} #{index + 1}</span>
        <button type="button" onClick={onRemove} className="text-red-400 hover:text-red-300 text-xs font-medium">Sil</button>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div className="space-y-1">
          <Label className="text-xs text-gray-400">Talep Yeri</Label>
          <Select value={item.talep_yeri || ''} onValueChange={(value) => onUpdate('talep_yeri', value)}>
            <SelectTrigger className="bg-gray-700 border-gray-600 text-white h-9 text-sm"><SelectValue placeholder="Talep Yeri Seç" /></SelectTrigger>
            <SelectContent className="bg-gray-800 border-gray-700 text-white">
              <SelectItem value="yigm">YİGM</SelectItem>
              <SelectItem value="spor_toto">SPOR TOTO</SelectItem>
              <SelectItem value="strateji">STRATEJİ</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-gray-400">Ek Talep Tarihi</Label>
          <Input type="date" value={item.tarih || ''} onChange={(e) => onUpdate('tarih', e.target.value)} className="bg-gray-700 border-gray-600 text-white text-sm h-9" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-gray-400">Talep Yazısı</Label>
          <Input placeholder="Yazı No" value={item.yazisi || ''} onChange={(e) => onUpdate('yazisi', e.target.value)} className="bg-gray-700 border-gray-600 text-white text-sm h-9" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-gray-400">Talep Tutarı</Label>
          <Input placeholder="Tutar" value={displayMoney(item.tutari || '')} onChange={(e) => onUpdate('tutari', e.target.value.replace(/ TL/g, ''))} className="bg-gray-700 border-gray-600 text-white text-sm h-9" />
        </div>
        <div className="space-y-1">
          <Label className="text-xs text-gray-400">Ödenek Durumu</Label>
          <Select value={item.durumu || ''} onValueChange={(value) => onUpdate('durumu', value)}>
            <SelectTrigger className="bg-gray-700 border-gray-600 text-white h-9 text-sm"><SelectValue placeholder="Durum" /></SelectTrigger>
            <SelectContent className="bg-gray-800 border-gray-700 text-white">
              <SelectItem value="geldi">GELDİ</SelectItem>
              <SelectItem value="gelmedi">GELMEDİ</SelectItem>
              <SelectItem value="iptal_edildi">İPTAL EDİLDİ</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
}
